import React from 'react';
import './styles.scss';
import NoImage from '../../../assets/icon/illustrations_no-document.svg';
import { ContentSectionDetail } from '../ContentSection';
import { useDisclosure } from '@mantine/hooks';
import { Flex, Group, Image, Stack, Text } from '@mantine/core';
import { getSharepointCdnFile } from '../../../utilities';
import Button from '../../elements/Button';
import { FiArrowRight } from 'react-icons/fi';
import ModalDetailPersonalWisdom from './ModalDetailPersonalWisdom';
import { useMutation } from '@tanstack/react-query';
import { addPoint } from '../../../services/homepage';
import {store} from "../../../store/AppStore";

const PersonalWisdomItem: React.FC<ContentSectionDetail> = ({
  id,
  backgroundImageFilePath,
  shortDescription,
  imageFilePath,
  isHomepage,
  position,
  content,
  title,
  unit,
  name,
  isPreview,
  wisdomContent,
  breakpoint
}) => {
  const [opened, { open, close }] = useDisclosure(false);

  const completedMission = useMutation({
    mutationFn: addPoint
  });

  const checkIsUserLoggedIn = () => {
      const reduxState: any = store.getState();
      return !!reduxState.auth?.userData?.binusianId;
  }

  const handleAddPoint = (data) => {
    let payload = {
      idLearningPage: data,
      from: 'Personal Wisdom'
    };
    completedMission.mutate(payload);
  };

  return (
    <>
      <Group
        align="center"
        gap={24}
        style={{
          backgroundImage: `url(${getSharepointCdnFile(
            backgroundImageFilePath
          )})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          padding: isPreview && breakpoint === 'mobile' && '1rem',
          width: isPreview && breakpoint === 'mobile' && '100%'
        }}
        className={`container-personal-wisdom-section__item container-personal-wisdom-section__item--homepage`}
      >
        <Flex direction={'column'} align={'flex-end'} flex={1} gap={12}>
          <Text
            fz={20}
            className="container-personal-wisdom-section__item__description"
          >
            "{wisdomContent || shortDescription}"
          </Text>

          <Flex justify={'space-between'} align={'center'} w={'100%'}>
            <div></div>

            <Stack gap={0}>
              <Text fz={16} fw={700} style={{ textAlign: 'right' }}>
                {name}
              </Text>
              <Text fz={14} style={{ textAlign: 'right' }}>
                {position}
              </Text>
              <Text fz={14} style={{ textAlign: 'right' }}>
                {unit}
              </Text>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%'
                }}
              >
                <Button
                  variant="transparent"
                  styles={{
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    padding: 0
                  }}
                  rightSection={<FiArrowRight />}
                  onClick={() => {
                      if(!checkIsUserLoggedIn()) {
                          handleAddPoint(id);
                      }
                      open();
                  }}
                >
                  See Details
                </Button>
              </div>
            </Stack>
          </Flex>
        </Flex>
        <div className="container-personal-wisdom-section__item__image-cover">
          <Image
            className="container-personal-wisdom-section__item__image"
            src={imageFilePath ? getSharepointCdnFile(imageFilePath) : NoImage}
            alt={name}
          />
        </div>
      </Group>

      <ModalDetailPersonalWisdom
        isVisible={opened}
        content={wisdomContent || content || shortDescription}
        name={name}
        unit={unit}
        photo={imageFilePath ? getSharepointCdnFile(imageFilePath) : NoImage}
        position={position}
        title={title}
        onClose={() => close()}
      />
    </>
  );
};

export default PersonalWisdomItem;
